import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, SxProps, Tooltip } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC, useState } from 'react';

const buttonSx: SxProps = {
    '&:hover': {
        color: 'grey.500',
    },
    color: 'grey.800',
    ml: 1,
};

interface ClipBoardButtonProps {
    textToCopy: string;
}

const ClipBoardButton: FC<ClipBoardButtonProps> = ({ textToCopy }) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation('common');

    return (
        <Tooltip
            onClose={() => setOpen(false)}
            title={open ? t('copyPastTitleDone') : t('copyPastTitle')}
            disableInteractive
        >
            <IconButton
                aria-label={t('copyPastTitle')}
                onClick={() => {
                    navigator.clipboard.writeText(textToCopy);
                    setOpen(true);
                }}
                size="small"
                sx={buttonSx}
            >
                <ContentCopyIcon />
            </IconButton>
        </Tooltip>
    );
};

export default ClipBoardButton;
